import {
  useEffect,
  useState,
} from 'react'

const KEY =
  'sei-os-entered-at'

function obtainStart() {
  const existing =
    sessionStorage.getItem(KEY)

  if (existing) {
    return Number(existing)
  }

  const start =
    Date.now()

  sessionStorage.setItem(
    KEY,
    String(start),
  )

  return start
}

function format(
  milliseconds: number,
) {
  const total =
    Math.floor(
      milliseconds /
        1000,
    )

  const h =
    Math.floor(
      total / 3600,
    )

  const m =
    Math.floor(
      (total % 3600) /
        60,
    )

  const s =
    total % 60

  return [
    h,
    m,
    s,
  ]
    .map(
      value =>
        String(value)
          .padStart(2, '0'),
    )
    .join(':')
}

export function SessionElapsed() {
  const [
    start,
  ] =
    useState(
      obtainStart,
    )

  const [
    now,
    setNow,
  ] =
    useState(
      Date.now(),
    )

  useEffect(() => {
    const timer =
      window.setInterval(
        () =>
          setNow(
            Date.now(),
          ),
        1000,
      )

    return () =>
      window.clearInterval(
        timer,
      )
  }, [])

  return (
    <span className="session-status">
      Sesión {format(now - start)}
    </span>
  )
}
